import React, { useState, useEffect } from 'react';
import {QRCodeCanvas} from 'qrcode.react';

const QRcodeComponent = () => {
    const [qrValue, setQrValue] = useState('');
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        setIsMounted(true);
        // Générer l'URL de destination avec paramètre
        const redirectUrl = `${window.location.origin}/reavie/register`;
        setQrValue(redirectUrl);

        // Nettoyage
        return () => setIsMounted(false);
    }, []);

    if (!isMounted) {
        return <div>Chargement...</div>;
    }

    return (


            <div >
                <QRCodeCanvas
                    value={qrValue}
                    size={256}
                    level="M"
                />
            </div>

    );
};

export default QRcodeComponent;